exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container{background-color:white;padding:24px}.ck-editor__editable{min-height:320px}\n", ""]);

// exports
